import { formatUrl } from 'url-lib';
import Cookies from 'cookies-js';

import { fetchJSON } from 'js-utils/http';
import { pruneObject } from '@eb/destination-utils';
import omit from 'lodash/omit';

import { deepKeysToSnake, keysCamelToSnake } from 'js-utils/transformation';
import { CURRENT_FUTURE, QUALITY } from '../constants';

const searchUrl = '/api/v3/destination/search/';
const searchAutocompleteSuggestionsUrl =
    '/api/v3/destination/search/autocomplete/';

const overrideJanus = (experimentOverride) => {
    Cookies.set('janus', `v=1&${experimentOverride.experimentName}=${experimentOverride.variant}`, {
        // Domain should look like .eventbrite.com, .evbqa.com, .evbdev.com, etc
        domain: window.location.hostname.replace('www', ''),
    });
};

const undoJanusOverride = (originalJanusCookie) => {
    Cookies.set('janus', originalJanusCookie);
};

const shouldOverrideJanus = (isStaff, experimentOverride) => isStaff && experimentOverride.experimentName !== 'none';

export const search = ({ searchQuery, experimentOverride, isStaff }) => {
    // The search API allows either a bbox or a WOF placeID but not both
    let searchQueryFiltered =
        searchQuery.bbox && searchQuery.places
            ? omit(searchQuery, 'places')
            : searchQuery;

    const requestParameters = {
        event_search: deepKeysToSnake(
            pruneObject({ ...searchQueryFiltered, page_size: 20 }),
        ),
        'expand.destination_event': [
            'primary_venue',
            'image',
            'ticket_availability',
            'saves',
            'series',
            'my_collections',
            'event_sales_status',
        ],
    };

    const originalJanusCookie = Cookies.get('janus');

    if (shouldOverrideJanus(isStaff, experimentOverride)) {
        overrideJanus(experimentOverride);
    }

    const fetchReq = fetchJSON(searchUrl, {
        method: 'POST',
        body: JSON.stringify(requestParameters),
    });

    if (shouldOverrideJanus(isStaff, experimentOverride)) {
        undoJanusOverride(originalJanusCookie);
    }

    return fetchReq;
};

export const searchAutocompleteSuggestions = ({
    placeId,
    onlineEventsOnly,
    query,
}) => {
    let queryParams = {
        placeId,
        q: query,
        completionTypes: ['event', 'query'],
        'expand.destination_event': ['primary_venue', 'image'],
    };

    if (onlineEventsOnly) {
        queryParams.onlineEventsOnly = true;
    }

    queryParams = keysCamelToSnake(queryParams);
    return fetchJSON(formatUrl(searchAutocompleteSuggestionsUrl, queryParams));
};

export const searchSuggestionsForCity = ({ placeId, onlineEventsOnly }) =>
    fetchJSON(searchUrl, {
        method: 'POST',
        body: JSON.stringify({
            event_search: {
                places: placeId ? [placeId] : [],
                online_events_only: onlineEventsOnly,
                dates: CURRENT_FUTURE,
                sort: QUALITY,
                aggs: {
                    tags: {},
                },
            },
            'expand.destination_event': [
                'primary_venue',
                'image',
                'ticket_availability',
                'saves',
                'my_collections',
            ],
        }),
    });
